import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/promotorEncuestadoEntregas2";

// ─── CARGA MASIVA (PAGINADA) ───────────────────────────────────────────────────
export const obtenerTodosEntregasEnBloques = async (
  onProgress,
  total = 0,
  blockSize = 500
) => {
  const todos = [];
  let lastId = 0;
  let hasMore = true;

  while (hasMore) {
    const resultado = await obtenerEntregasPaginado(lastId, blockSize);
    todos.push(...resultado.data);

    hasMore = resultado.hasMore;
    lastId = resultado.nextCursor ?? 0;

    const porcentaje =
      total > 0
        ? Math.min(Math.round((todos.length / total) * 100), 99)
        : null;

    onProgress?.(porcentaje, todos.length, total);
  }

  return todos;
};

// ─── PAGINACIÓN ───────────────────────────────────────────────────────────────
export const obtenerEntregasPaginado = async (lastId = 0, pageSize = 30) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}`, {
      params: { lastId, pageSize },
    });
    return response.data;
  } catch (error) {
    console.error("Error obteniendo entregas paginadas:", error);
    throw error;
  }
};

export const obtenerTotalEntregas = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/total`);
    return response.data.total;
  } catch (error) {
    console.error("Error obteniendo total:", error);
    throw error;
  }
};

// ─── FILTROS SIMPLES ──────────────────────────────────────────────────────────

export const obtenerPorMunicipio = async (municipioId) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/municipio/${municipioId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por municipio:", error);
    throw error;
  }
};

export const obtenerPorDepartamento = async (departamentoId) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/departamento/${departamentoId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por departamento:", error);
    throw error;
  }
};

// 🔥 REEMPLAZA PROMOTOR
export const obtenerPorUsuario = async (usuarioId) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/usuario/${usuarioId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por usuario:", error);
    throw error;
  }
};

export const obtenerPorEncuesta = async (idEncuesta) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/encuesta/${idEncuesta}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por encuesta:", error);
    throw error;
  }
};

export const obtenerPorEstado = async (estado) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/estado/${estado}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por estado:", error);
    throw error;
  }
};

export const obtenerPorDocumento = async (documento) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/documento/${documento}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por documento:", error);
    throw error;
  }
};

export const obtenerPorNroEntrega = async (nroEntrega) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/nro-entrega/${nroEntrega}`
    );
    return response.data;
  } catch (error) {
    console.error("Error por número de entrega:", error);
    throw error;
  }
};

// ─── FILTROS DINÁMICOS ────────────────────────────────────────────────────────
export const obtenerConFiltros = async (filtros = {}) => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/filtros`, {
      params: filtros,
    });
    return response.data;
  } catch (error) {
    console.error("Error con filtros dinámicos:", error);
    throw error;
  }
};

// ─── CATÁLOGOS ────────────────────────────────────────────────────────────────

export const obtenerMunicipios = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/municipios`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo municipios:", error);
    throw error;
  }
};

export const obtenerDepartamentos = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/departamentos`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo departamentos:", error);
    throw error;
  }
};

export const obtenerUsuarios = async (municipioId = null) => {
  try {
    const params = municipioId ? { municipioId } : {};
    const response = await axios.get(
      `${baseUrl}${endpoint}/usuarios`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error obteniendo usuarios:", error);
    throw error;
  }
};